import { asyncRouterMap, constantRouterMap } from '@/router'
// import store from '@/store'
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(perms, route) {  // 判断是否有权限

    /**
     * perms   []
     *  [a,s]    [a,b,c,d].some(a=>  [a,b].includes(a)   )
     */


    if (route.meta && route.meta.perms) {
        console.log('检查权限',route.meta)
        return perms.some(perm => route.meta.perm.includes(perm))
    } else {
        return true
    }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, perms) {  // 过滤没有权限的列表 循环过滤 直到没有子路由
    const res = [];
    routes.forEach(route => {
        const tmp = { ...route }
        if (hasPermission(perms, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRouter(tmp.children, perms)
            }
            res.push(tmp)
        }
    })
    return res
}

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: []
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {  // 保存动态路由时 将静态路由和动态路由合并
            state.addRouters = routers
            state.routers = constantRouterMap.concat(routers)
        }
    },
    actions: {
        GenerateRoutes({ commit }, data) {
            return new Promise(resolve => {
                const roles = data.roles;
                const perms = data.perms;
                let accessedRouters
                if (perms) {
                    if (roles.includes(1)) {  // 如果未admin角色 加载所有动态路由
                        accessedRouters = asyncRouterMap
                    } else {  // 如果不是admin角色 则加载过滤后的动态路由
                        accessedRouters = filterAsyncRouter(asyncRouterMap, perms)
                    }
                    commit('SET_ROUTERS', accessedRouters)  // 保存路由
                }
                resolve()
            })
        }
    }
}

export default permission
